
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Layout from "./components/Layout";
import DealerOnboarding from "./pages/DealerOnboarding";
import Dashboard from "./pages/Dashboard";
import LeadUpload from "./pages/LeadUpload";
import CallDetails from "./pages/CallDetails";
import AdminDashboard from "./pages/AdminDashboard";
import LeadCallFlowPage from "./pages/LeadCallFlowPage";
import ConversationDetail from "./components/admin/ConversationalAI/ConversationDetail";

const queryClient = new QueryClient();

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route element={<Layout />}>
                <Route path="/onboarding" element={<DealerOnboarding />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/leads/upload" element={<LeadUpload />} />
                <Route path="/calls/:id" element={<CallDetails />} />
                <Route path="/leads/:id/call-flow" element={<LeadCallFlowPage />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/conversations/:id" element={<ConversationDetail />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
